import React from "react";
import styled from "styled-components";
import useResponsiveImageUrl from "src/utils/useResponsiveImageUrl";

/**
 * StatusBackground component - A reusable full-screen background container
 * for status and confirmation pages. Provides consistent layout with
 * background image, centering, and responsive behavior.
 *
 * @param {ReactNode} children - Content to display in the centered container
 */
const StatusBackground = ({ children }) => {
  const backgroundImage = useResponsiveImageUrl("reg/bg-login.png");

  return (
    <MainDiv bgImage={backgroundImage}>
      <ContentContainer>
        <container-div>
          {children}
        </container-div>
      </ContentContainer>
    </MainDiv>
  );
};

const MainDiv = styled.div`
  width: 100%;
  position: relative;
  z-index: 0;
  height: auto;
  min-height: 80vh;
  background-image: url(${(props) => props.bgImage});
  padding: 100px 0 20px 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ContentContainer = styled.div`
  padding: 1rem 1rem 2rem;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  max-width: 750px;
  .title-section {
    h1 {
      color: var(--lightgrey);
      margin: 0px;
      font-weight: 700;
      font-size: 2rem;
    }
    p {
      color: var(--lightgrey);
      font-size: 1rem;
    }
  }
`;

export default StatusBackground;
